export const DISCOUNT_FETCH_SUCCESSFULLY= 'DISCOUNT_FETCH_SUCCESSFULLY'
export function discountFetchSuccesfully(discounts){
    return{
        type: DISCOUNT_FETCH_SUCCESSFULLY,
        discounts: discounts
    }
}



// WEBPACK FOOTER //
// src/model/DiscountCode/actions.js